module.exports = __webpack_public_path__ + "img/calendar-4_fill.f268367d.svg";